// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__8HDHp","employee-header-item":"Header_employee-header-item__Rlc4Y"};